/**
 * TutorialCanvasBridge — hands the running tutorial the editor's own actions.
 *
 * Renders nothing. It exists only so that a step, which is plain data living
 * outside React, can call `updateSituation` or `deleteChoice` when the bus tells
 * it the user just dropped a node or drew the wrong edge.
 *
 * Mounted inside CreateScenario, so it is present exactly when those actions are
 * meaningful and unregisters itself when the editor unmounts.
 */

import { useCanvas } from '../../context/CanvasContext';
import { useEditorUI } from '../../context/EditorUIContext';
import useRegisterTutorialActions from './useRegisterTutorialActions';

const TutorialCanvasBridge = () => {
    const { updateSituation, updateChoice, deleteSituation, deleteChoice } = useCanvas();
    const { selectItem, clearSelection, setActiveEditTab } = useEditorUI();

    useRegisterTutorialActions({
        updateSituation,
        updateChoice,
        deleteSituation,
        deleteChoice,
        selectItem,
        clearSelection,
        setActiveEditTab,
    });

    return null;
};

export default TutorialCanvasBridge;
